import { render, staticRenderFns } from "./CapituloCinco18Page.vue?vue&type=template&id=4a0daa5a"
import script from "./CapituloCinco18Page.js?v=1?vue&type=script&lang=js&external"
export * from "./CapituloCinco18Page.js?v=1?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports